<template>
  <div style="width:1.8rem;border: 0.01rem solid rgb(204, 204, 204);">
      <el-menu class="el-menu-vertical-demo" active-text-color="#228457" router>
        <!-- <el-submenu index='1'>
          <template slot='title'>我的钱包</template>
          <el-menu-item index='/education/personalcenter/balance'>余额</el-menu-item>
          <el-menu-item index="/education/personalcenter/integral">积分</el-menu-item>
        </el-submenu> -->
<!--        <el-submenu index="2">-->
<!--          <template slot='title'>订单中心</template>-->
            <el-menu-item style="padding: 0 0 0 20px !important;" index="/education/personalcenter/userinfo">个人信息</el-menu-item>
            <el-menu-item index="/education/personalcenter/securityset">账户安全</el-menu-item>
            <el-menu-item v-if="zhuanjia" index='/education/personalcenter/apply'>摄影师信息</el-menu-item>
            <el-menu-item v-if="!zhuanjia" index='/education/personalcenter/apply'>申请成为摄影师</el-menu-item>
            <el-menu-item v-if="zhuanjia" index="/education/personalcenter/mypicfile">我上传的图片</el-menu-item>
            <el-menu-item v-if="zhuanjia" index="/education/personalcenter/mypicbuy">我的购买记录</el-menu-item>
            <el-menu-item index='/education/personalcenter/collect'>我的收藏</el-menu-item>
            <el-menu-item index='/education/personalcenter/download'>我的下载</el-menu-item>
      </el-menu>
  </div>
</template>

<script>
import { getUser } from '@/untils/auth'
export default {
  name: 'layoutleft',

  data() {
    return {
      zhuanjia: false,
    }
  },

  created (){
    var VUserId = JSON.parse(getUser()).principal.VUserId
    this.axios.post(window.IPConfig.IP + "/tBUserRole/queryByUserId.do",{VUserId:VUserId}).then((res) => {
      if (res.status == 200) {
        console.log(res)
        if (res.data.status == 200) {
            this.zhuanjia = true
        }
      }
    });

  },

}
</script>

<style lang="stylus" scoped>
//.el-menu-vertical-demo {
//    margin-top .2rem
//}

.el-menu-item, .el-submenu__title {
  height: 54px;
  line-height: 54px;
  position: relative;
  -webkit-box-sizing: border-box;
  white-space: nowrap;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/components/layoutleft.vue